import { truncate } from 'lodash';
import moment from 'moment';
import 'moment/locale/es';
import numeral from 'numeral';
import Vue from 'vue';
import { License, Price } from './opds2';

moment.locale('fr');

export default function addCustomFilters() {
  Vue.filter('formatDate', (value: any) => {
    if (value) {
      return moment(String(value)).calendar();
    }
  });

  Vue.filter('truncate', (value: string, length: number) => {
    return truncate(value, { length, separator: ' ' });
  });

  Vue.filter('stripHtml', (value: string) => {
    const temporalDivElement = document.createElement('div');
    temporalDivElement.innerHTML = value;
    return temporalDivElement.textContent || temporalDivElement.innerText || '';
  });

  Vue.filter('price', (price: Price, count: number = 1) => {
    return `${price.currency} ${numeral(price.value * count).format('0.00')}`;
  });

  Vue.filter('license', (value: License) => {
    let format = value.metadata.format;
    switch (format) {
      case 'application/epub+zip':
        format = 'EPUB';
        break;
      case 'application/pdf':
        format = 'PDF';
        break;
    }
    const price = `${value.metadata.price.currency} ${value.metadata.price.value}`;
    return `${format} (prets: ${value.metadata.terms.checkouts}|sim: ${
      value.metadata.terms.concurrency
    }|${value.metadata.terms.duration || ' '}|${price})`;
  });
}
